<template>
  <div class="subview4_father">
    <div class="view4_father">
      <div class="left_father">
        <div class="left_div">
          <div>
            <p class="title">职能集成化</p>
            <p class="content">
              企业综合管理一站式服务将不同部门的多个相关职能整合在一起，打破了部门间的业务壁垒与办公场地界限，建立部门间协同联动机制，让员工享受一站式办理服务，有效的缩短了业务办理时间。
            </p>
          </div>
          <img src="../../../static/img/一站式点.png" />
        </div>
      </div>
      <hr class="line" />
      <div class="right_father">
        <div class="right_div">
          <div>
            <p class="title">以服务对象为关注点</p>
            <p class="content">
              企业管理机关从员工的需求出发，设计服务内容、优化审批流程、提高办事效率、改善工作质量，避免员工在不同部门之间奔波、等待、往复，为员工提供最大的服务效益。
            </p>
          </div>
          <img src="../../../static/img/一站式点.png" />
        </div>
        <div class="right_div">
          <div>
            <p class="title">个性化自主化</p>
            <p class="content">
              提高企业综合管理机关的服务与保障能力，能够向员工提供“一对一”的服务，员工可在一站式服务中心自助发起并办理业务，可以充分改善机关形象，提升员工满意度。
            </p>
          </div>
          <img src="../../../static/img/一站式点.png" />
        </div>
      </div>
    </div>
    <div class="subview4_mid_div ">
      <div class="subview_item">
        <p class="title">一个业务窗口</p>
        <p class="content">
          改变传统业务受理模式，改造并优化业务办理流程，将一站式服务中心作为综合管理机关与员工的唯一接口，业务受理、咨询、结果反馈均集中至一个业务窗口，大幅度提高了业务办理效率，改善了机关形象。
        </p>
      </div>
      <div class="subview_item">
        <p class="title">一套办事流程</p>
        <p class="content">
          梳理机关内部及对外的业务流程与接口关系，规范业务受理、流转、上报审批及反馈等流程，将业务流程封闭在管理机关内部，把便利留给员工。
        </p>
      </div>
      <div class="subview_item">
        <p class="title">一本工作指南</p>
        <p class="content">
          明确了各类业务办理的材料清单、归口主管、申请表单、业务办理流程等信息，并在内部网站上设置一站式服务专区，实现工作指南电子化，确保员工材料准备充足、业务咨询便捷，大幅提高业务办理一次性审批通过的比例，提高了办事效率
        </p>
      </div>
      <div class="subview_item">
        <p class="title">一套标准表格</p>
        <p class="content">
          将一站式服务中心的所有业务涉及到的审批表格分类、编号，并制作业务指南看板，目录上墙，进一步降低员工的获取难度。
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  computed: {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>
<style lang="stylus" scoped>
.subview4_father > div:first-child {
  border-top: 1px dashed var(--textBlack);
  border-bottom: 1px dashed var(--textBlack);
}

.view4_father {
  margin: 5rem 0 0;
  display: flex;
  height: 70rem;
  justify-content: center;
  padding: 5rem 0;

  .line {
    height: 100%;
    border: 1px dashed var(--textBlack);
  }
}

.left_father {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: -0.9rem;
}

.left_div {
  text-align: right;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  // margin-right: -0.9rem;
  position: relative;

  div {
    background-image: url('../../../static/img/一站式左bg.png');
    background-repeat: no-repeat;
    background-size: contain;
    width: 58rem;
    height: 21rem;
    padding: 4rem 6rem;
    margin-right: 3rem;
  }

  img {
    width: 1.6rem;
    height: 1.6rem;
    margin: 3rem 0 0;
    position: absolute;
    top: 0;
  }

  .title {
    font-size: 2.4rem;
  }

  .content {
    text-align: justify;
    font-size: 1.8rem;
    color: var(--textBlack);
  }
}

.right_father {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: -0.9rem;
}

.right_div {
  display: flex;
  // width:50%;
  text-align: left;
  flex-direction: row-reverse;
  justify-content: flex-start;

  div {
    background-image: url('../../../static/img/一站式右bg.png');
    background-repeat: no-repeat;
    background-size: contain;
    width: 58rem;
    height: 21rem;
    padding: 4rem 6rem;
  }

  .title {
    font-size: 2.4rem;
  }

  .content {
    text-align :justify;
    font-size: 1.8rem;
    color: var(--textBlack);
  }

  img {
    width: 1.6rem;
    height: 1.6rem;
    margin: 3rem 3rem 0 0;
  }
}

.subview4_mid_div {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 12rem 0;
  border-bottom: 1px dashed var(--textBlack);

  .subview_item {
    width: 29rem;
    height: 38rem;

    .title {
      padding: 1.4rem 7rem;
      background: var(--textBlue);
      color: white;
      font-size: 2.2rem;
      box-shadow: 7px 7px 7px rgba(0, 0, 0, 0.3);
    }

    .content {
      height: 30rem;
      text-align: left;
      padding: 6rem 4rem;
      background: var(--divGaryE250);
      color: var(--textBlack);
      font-size: 1.4rem;
      box-shadow: 7px 7px 7px rgba(0, 0, 0, 0.3);
    }
  }
}

@media (max-width: 800px) {
  .subview4_mid_div {
    padding:2rem 0 12rem;
    .subview_item {
      margin-top: 10rem;
      margin-bottom: 10rem;
      .content {
        height: 45rem;
      }
    }
  }
  .startMargin {
    margin-top: 10rem;
  }

  .endMargin {
    margin-bottom: 10rem;
  }
}
</style>